import { AuthAction, AuthMutation } from "../types";

export default {
  [AuthAction.setUser]({ commit }: any, user: any) {
    commit(AuthMutation.SET_USER, user);
  },
  [AuthAction.setDeviceId]({ commit }: any, deviceId: any) {
    commit(AuthMutation.SET_DEVICE_ID, deviceId);
  },
  [AuthAction.setTenantCode]({ commit }: any, tenantCode: any) {
    commit(AuthMutation.SET_TENANT_CD, tenantCode);
  },
  [AuthAction.setStaff]({ commit }: any, staff: any) {
    commit(AuthMutation.SET_STAFF, staff);
  },
  [AuthAction.logout]({ commit }: any) {
    commit(AuthMutation.SET_DEVICE_ID, "");
    commit(AuthMutation.SET_USER, {});
    commit(AuthMutation.SET_STAFF, {});
    commit(AuthMutation.LOGOUT);
  },
  [AuthAction.onNotifyMyself]({ commit }: any, data: any) {
    // 何もしない
  },
  [AuthAction.oneTimeToken]({ commit }: any, data: string) {
    commit(AuthMutation.SET_ONE_TIME_TOKEN, data);
  },
  [AuthAction.userAgent]({ commit }: any, data: string) {
    commit(AuthMutation.SET_USER_AGENT, data);
  },
  [AuthAction.subscriptionEndpoint]({ commit }: any, data: string) {
    commit(AuthMutation.SET_SUBSCRIPTION_ENDPOINT, data);
  },
};
